import { render, staticRenderFns } from "./course.vue?vue&type=template&id=253efc09&scoped=true&"
import script from "./course.vue?vue&type=script&lang=js&"
export * from "./course.vue?vue&type=script&lang=js&"
import style0 from "./course.vue?vue&type=style&index=0&id=253efc09&prod&lang=scss&"
import style1 from "./course.vue?vue&type=style&index=1&id=253efc09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253efc09",
  null
  
)

export default component.exports